import React from "react";
import laptop from "../assets/iPad Pro 2020.png"
import './whychooseus.css';

function WhyChooseUs() {
  return (
    <div className="why-choose-us">
      <div className="why-choose-us-text">
        <h2>Why Choose Us</h2>
        <ul>
          <li>Get the best value for your money with our unbeatable currency exchange rates.</li>
          <li>Enjoy hassle-free forex buying and selling with industry-leading security measures.</li>
          <li>Trade seamlessly with our intuitive and easy-to-navigate interface.</li>
          <li>Access a wide range of currencies from anywhere in the world.</li>
        </ul>
      </div>

      <div className="why-choose-us-image">
        <img  style={{height:'300px'}} src={laptop} alt="iPad Pro 2020" />
      </div>
    </div>
  );
}

export default WhyChooseUs;
